export const regexLibrary = {
    time: /\b(1[0-2]|0[1-9]):([0-5][0-9]) ([AP]M)/,
    date: /^\d{2}\/\d{2}\/\d{4}$/,
    directAddress: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    emailAddress: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
    preventAsterisk: "^[^*]+$"
};
